import styled from 'styled-components';
import { colors } from '../../../../assets';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ConfigContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	margin-bottom: 1rem;
`;

export const Config = styled.div`
	display: flex;
	background-color: ${colors.darkGray};
	padding: 1.5rem;
	align-items: center;
	border-radius: ${({ isOpen }) =>
		isOpen ? '0.9375rem 0.9375rem 0 0' : '0.9375rem'};
`;

export const Divisor = styled.div`
	height: 1px;
	background-color: ${colors.gray};
	margin-bottom: 3rem;
`;

export const ExpandedContent = styled.div`
	display: ${(props) => (props.isOpen ? 'block' : 'none')};
	width: 100%;
	background-color: ${colors.darkGray};
	padding: 1.5rem;
	border-radius: 0 0 0.9375rem 0.9375rem;
	.button-group {
		display: flex;
		justify-content: flex-end;
		gap: 1rem;
	}
	.button-custom {
		height: 2.8125rem;
	}

	.checkbox-custom {
		display: flex;
		justify-content: flex-start;
		height: fit-content;
		color: ${({ checked }) => (checked ? colors.primaryBlue : colors.lightGray)};
	}

	.label-underline-input {
		font-style: normal;
		font-weight: normal;
		font-size: 1rem;
		line-height: 1.3125rem;
	}
	.info-icon-outlined {
		margin-left: 0.625rem;
	}
	.
`;

export const Icon = styled.div`
	display: flex;
	padding: 0.5rem;
	border: 1px solid ${colors.primaryBlue};
	border-radius: 0.5rem;
	background: rgba(99, 210, 237, 0.1);
`;

export const Title = styled.h3`
	font-size: 1.5rem;
	line-height: 1.9375rem;
	color: ${colors.primaryBlue};
	line-height: 1.9375rem;
	font-style: normal;
	font-weight: normal;
`;

export const Info = styled.span`
	font-size: 1.25rem;
	line-height: 1.625rem;
	color: ${colors.offWhite};
`;

export const MidContent = styled.div`
	display: flex;
	flex-direction: column;
	margin-left: 1.5rem;
	gap: 1rem;
`;

export const Row = styled.div`
	display: flex;
	gap: 4rem;
`;

export const ExpandIcon = styled.div`
	display: flex;
	align-items: center;
	border: 1px solid ${colors.lightGray};
	border-radius: 0.3125rem;
	background-color: transparent;
	cursor: pointer;
	transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
	margin-left: auto;
	svg {
		width: 1.875rem;
		height: 1.875rem;
	}
`;

export const InputGroup = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 3.5rem;
	:not(.radio-group) {
		gap: 2.625rem;
	}
	.label-underline-input {
		font-style: normal;
		font-weight: normal;
		font-size: 1rem;
		line-height: 1.3125rem;
		color: ${colors.offWhite};
		width: 15rem;
	}

	.custom-select-input {
		border-radius: 0;
		border-bottom: 1px solid
			${({ readOnly }) => (readOnly ? colors.gray : colors.primaryBlue)};
		label {
			color: ${({ readOnly }) => (readOnly ? colors.gray : colors.primaryBlue)};
		}
	}
`;

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;

	.aditional-form {
		display: ${({ checked }) => (checked ? 'flex' : 'none')};
	}
`;

export const ReadOnlyText = styled.span`
	font-style: normal;
	font-weight: 400;
	font-size: 1.25rem;
	line-height: 1.625rem;
	color: ${colors.lightGray};
`;

export const ButtonGroup = styled.div`
	display: flex;
`;

export const GroupContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 3rem;
`;

export const RadioGroup = styled.div`
	display: flex;
	gap: 2rem;
	margin-bottom: 2rem;
`;

export const GroupTitle = styled.h2`
	font-family: Jost;
	font-style: normal;
	font-weight: 500;
	font-size: 1.375rem;
	line-height: 2rem;
	letter-spacing: 0.04rem;
	color: ${colors.offWhite};
`;

export const TitleInput = styled.h4`
	color: ${colors.offWhite};
	font-size: 1rem;
	font-style: normal;
	font-weight: normal;
	padding-bottom: 1rem;
`;

export const ButtonsTabs = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 28rem;
	height: 2.1875rem;
	background: ${colors.gray};
	border: 1px solid ${colors.gray};
	border-radius: 0.5rem;
	padding: 1px;
	box-shadow: inset 0px 0px 7px rgba(0, 0, 0, 0.6);
	margin-bottom: 4.5rem;

	${({ selected }) =>
		selected === 'start'
			? '#inicio { margin-left: -2px; }'
			: '#final { margin-right: -2px; }'};
`;

export const Button = styled.button`
	background: none;
	font-size: 0.875rem;
	font-weight: 600;
	letter-spacing: 0.02em;
	padding: 0 0.625rem;
	position: relative;
	text-align: center;
	text-transform: none;
	color: ${colors.lightGray};
	border-radius: 0.5rem;
	width: 50%;

	:hover {
		color: ${({ selected }) => !selected && colors.primaryBlue};
	}

	${({ selected }) =>
		selected &&
		`
		font-weight: 600;
		color: ${colors.background};
		background: ${colors.primaryBlue};
		border: 1px solid ${colors.darkTurquoise};
		animation: aparecer 0.4s ease-out;
		backdrop-filter: blur(10px);
		height: 2.1875rem;
		`};

	:disabled {
		opacity: 0.3;
	}
`;

export const RowsGroup = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 4.625rem;
`;
export const BankRow = styled.div`
	display: flex;
	gap: 2rem;
	margin-bottom: 2rem;
	div:first-child {
		width: 20.5rem;
	}
`;
